// Project Status Constants

export const STATUS_CODES = {
  NOT_STARTED: 1,
  CONTRACT: 2,
  PAYMENT: 3,
  IN_PROGRESS: 4,
  MILESTONE: 5,
  ON_HOLD: 107,
  CONFLICT: 108,
  DISPUTE: 109,
  COMPLETED: 110
} as const;

export const STATUS_KEYS = {
  NOT_STARTED: 'not_started',
  CONTRACT: 'contract',
  PAYMENT: 'payment',
  IN_PROGRESS: 'in_progress',
  MILESTONE: 'milestone',
  ON_HOLD: 'on_hold',
  CONFLICT: 'conflict',
  DISPUTE: 'dispute',
  COMPLETED: 'completed'
} as const;

// Sub-status keys that represent error/failure states
export const ERROR_SUB_STATUSES = new Set(['rejected', 'failed', 'dispute']);

// Exception statuses that replace the timeline with a banner
export const EXCEPTION_STATUSES = new Set(['on_hold', 'conflict', 'dispute']);

// Map sortOrder to status key for timeline display
export const SORT_ORDER_TO_KEY: Record<number, string> = {
  1: 'not_started',
  2: 'contract',
  3: 'payment',
  4: 'in_progress',
  5: 'milestone',
  107: 'on_hold',
  108: 'conflict',
  109: 'dispute',
  110: 'completed'
};

// Exception banner configuration
export const EXCEPTION_CONFIG: Record<string, {
  color: string;
  icon: string;
  label_sv: string;
  label_en: string;
  description_sv: string;
  description_en: string;
  actionLabel_sv?: string;
  actionLabel_en?: string;
}> = {
  on_hold: {
    color: 'warning',
    icon: 'pause-circle',
    label_sv: 'Vilande',
    label_en: 'On Hold',
    description_sv: 'Projektet \u00e4r vilande och inv\u00e4ntar \u00e5tg\u00e4rd.',
    description_en: 'The project is on hold and awaiting action.',
    actionLabel_sv: '\u00c5teruppta projekt',
    actionLabel_en: 'Resume project'
  },
  conflict: {
    color: 'danger',
    icon: 'alert-triangle',
    label_sv: 'Konflikt',
    label_en: 'Conflict',
    description_sv: 'Projektet \u00e4r i konfliktl\u00e4ge och beh\u00f6ver extern hj\u00e4lp f\u00f6r att n\u00e5 en l\u00f6sning.',
    description_en: 'The project is in conflict handling and needs external help to reach a resolution.',
    actionLabel_sv: 'Visa konflikt\u00e4rende',
    actionLabel_en: 'View conflict'
  },
  under_resolution: {
    color: 'warning',
    icon: 'tool',
    label_sv: 'Åtgärdas',
    label_en: 'Being remedied',
    description_sv: 'Hantverkaren åtgärdar etappen. Konfliktärendet kan fortfarande öppnas av båda parter.',
    description_en: 'The contractor is remedying the milestone. Both parties can still open the conflict case.',
    actionLabel_sv: 'Visa konfliktärende',
    actionLabel_en: 'View conflict'
  },
  disputed: {
    color: 'warning',
    icon: 'message-circle',
    label_sv: 'Under invändning',
    label_en: 'Under objection',
    description_sv: 'Etappen är under invändning och parterna fortsätter dialogen.',
    description_en: 'The milestone is under objection and the parties continue the dialogue.',
    actionLabel_sv: 'Visa konfliktärende',
    actionLabel_en: 'View conflict'
  },
  external_dispute: {
    color: 'danger',
    icon: 'x-octagon',
    label_sv: 'Tvist',
    label_en: 'Dispute',
    description_sv: 'Ärendet hanteras externt. Etappios utbetalningar är stoppade och konfliktärendet är fortsatt tillgängligt.',
    description_en: 'The case is handled externally. Etappio payouts are blocked and the conflict case remains available.',
    actionLabel_sv: 'Visa konfliktärende',
    actionLabel_en: 'View conflict'
  },
  dispute: {
    color: 'danger',
    icon: 'x-octagon',
    label_sv: 'Tvist',
    label_en: 'Dispute',
    description_sv: 'Ärendet hanteras externt. Etappios utbetalningar är stoppade och en tvistexport kan hämtas från det berörda kontraktet.',
    description_en: 'The case is handled externally. Etappio payouts are blocked and a dispute export is available on the affected contract.'
  }
};

// Dot color to CSS mapping
export const DOT_COLORS: Record<string, { bg: string; border: string }> = {
  green: { bg: '#28a745', border: '#28a745' },
  blue: { bg: '#007bff', border: '#007bff' },
  grey: { bg: '#dee2e6', border: '#adb5bd' },
  red: { bg: '#dc3545', border: '#dc3545' }
};
